import { Dialog } from "primereact/dialog";
import { JVInput } from "../../../shared/JVInput";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { IEscalationStatus } from "../statusMaster";
import { IEscalationType } from "../typeMaster";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { AutoComplete } from "primereact/autocomplete";
import { JVMultiselect } from "../../../shared/JVMultiselect";

interface IEscalationMast {
    id?: number,
    isDC?: boolean,
    type_ID?: number,
    status_ID?: number,
    comment?: string,
    consultant_ID?: number[],
    vendor_Company_ID?: number
}

interface IProps {
    open: boolean,
    singleData: any,
    setReLoad: () => void,
    hideDialog: () => void,
    poID?: number | null,
    toast: any
}

export interface IConsultants {
    consultant_ID?: number,
    consultant_Name?: string,
    vendor_Company_Name?: string
}

const schema = yup.object({
    isDC: yup.boolean().nullable(),
    type_ID: yup.number().required("Type Name is required*"),
    status_ID: yup.number().required("Status Active is required*"),
});

export const Form = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState<string>('');
    const [statusTable, setStatusTable] = useState({ tableData: [], loading: false } as { tableData: Array<IEscalationStatus>, loading: boolean });
    const [typeTable, setTypeTable] = useState({ tableData: [], loading: false } as { tableData: Array<IEscalationType>, loading: boolean });
    const [vendorCompanies, setVendorCompanies] = useState<Array<{ vendor_Company_ID?: number, vendor_Company_Name?: string, website_URL?: string, vendor_Type?: string, }>>([]);
    const [value2, setValue2] = useState(null as { vendor_Company_ID?: number, vendor_Company_Name?: string, website_URL?: string, vendor_Type?: string, } | null);
    const [selectedVendor, setSelectedVendor] = useState(4 as number | null);
    const [consultants, setConsultants] = useState<Array<IConsultants>>([]);
    const [selectedConsultants, setSelectedConsultants] = useState<Array<IConsultants>>([]);
    const [showVCComp, setShowVCComp] = useState<boolean>(false);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IEscalationMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit = async (data: IEscalationMast) => {
        if (selectedConsultants.length === 0 && (props.singleData.id === undefined || props.singleData.id === null)) {
            props.toast.current.show({ severity: 'error', detail: "Select at least 1 Consultant", life: 3000 });
            return;
        }
        if (value.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: "Comment is required", life: 3000 });
            return;
        }

        const newBody: any = {
            id: data.id,
            type_ID: data.type_ID,
            status_ID: data.status_ID,
            comment: value,
            consultant_ID: selectedConsultants.map((el: IConsultants) => el.consultant_ID),
            vendor_Company_ID: value2?.vendor_Company_ID || 0,
        };

        setLoading(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";
        const endPoint = props.singleData.id ? "updateEscalation" : "addEscalation";

        const response = await Fetch(("POEscalation/" + endPoint), method, newBody, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            onHide();
        } else setLoading(false);
    }

    const loadStatus = async () => {
        setStatusTable({ tableData: statusTable.tableData, loading: true });
        const response = await Fetch("POEscalation/getEscalationStatus", "GET", null, null, props.toast);
        if (response) {
            const data: IEscalationStatus[] = await response.json();
            setStatusTable({ tableData: data, loading: false });
        } else setStatusTable({ tableData: statusTable.tableData, loading: false });
    }

    const loadType = async () => {
        setTypeTable({ tableData: typeTable.tableData, loading: true });
        const response = await Fetch("POEscalation/getEscalationType", "GET", null, null, props.toast);
        if (response) {
            const data: IEscalationType[] = await response.json();
            setTypeTable({ tableData: data, loading: false });
        } else setTypeTable({ tableData: typeTable.tableData, loading: false });
    }

    const onHide = () => {
        setLoading(false);
        reset({
            isDC: true,
            type_ID: 0,
            status_ID: 0,
            comment: "",
        });
        setValue2(null);
        setSelectedConsultants([]);
        props.setReLoad();
        props.hideDialog();
    }

    const loadVendorCompanies = async (query: string) => {
        const repsonse = await Fetch("POEscalation/vendorCompanies", "GET", null, `query=${query}&vendorType=${4}`, props.toast);
        if (repsonse) {
            const data: Array<{ vendor_Company_ID?: number, vendor_Company_Name?: string, website_URL?: string, vendor_Type?: string, }> = await repsonse.json();
            setVendorCompanies(data);
        }
    }

    const completeMethodVendorCompany = (event: { query: string }) => {
        if (selectedVendor !== null && selectedVendor !== 0) {
            loadVendorCompanies(event.query);
        } else props.toast.current.show({ severity: 'error', detail: "Select Vendor Type First.", life: 3000 });
    }

    const loadConsultants = async (cID?: number) => {
        const response = await Fetch("POEscalation/getConsultantByVCid", "GET", null, (cID ? `cID=${cID}` : null), props.toast);
        if (response) {
            const data: IConsultants[] = await response.json();
            setConsultants(data);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "isDC") {
                if (value.isDC === true) {
                    setShowVCComp(false);
                } else {
                    setShowVCComp(true);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, showVCComp]);

    useEffect(() => {
        if (props.open) {
            setValue(props.singleData.comment || "");
            loadStatus();
            loadType();

            console.log(props.singleData);

            if (props.singleData.isDC === true) {
                setShowVCComp(false);
            } else setShowVCComp(true);

            if (props.singleData.id !== undefined && props.singleData.id !== null && props.singleData.id > 0) {
                reset({
                    id: props.singleData.id,
                    isDC: props.singleData.isDC,
                    type_ID: props.singleData.type_ID,
                    status_ID: props.singleData.status_ID,
                    comment: props.singleData.comment,
                });
            }
            else {
                reset({
                    type_ID: props.singleData.type_ID,
                    isDC: props.singleData.isDC,
                    status_ID: props.singleData.status_ID,
                    comment: props.singleData.comment,
                });
            }
            loadConsultants();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Escalation" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                {props.open && (props.singleData.id === undefined || props.singleData.id === null) && <div className="mt-5">
                    <JVCheckbox column={1} label="Independeant Candidate" control={control} name="isDC" />
                </div>}
                {(props.singleData.id === undefined || props.singleData.id === null) && (showVCComp) && <div className="flex" style={{ height: "35px", marginTop: "2%" }}>
                    <AutoComplete suggestions={vendorCompanies} completeMethod={completeMethodVendorCompany} field={"vendor_Company_Name"} forceSelection value={value2} placeholder={"Search Vendor Company"} onChange={(e) => setValue2(e.value)} />
                    <Button icon="pi pi-search" className="p-button p-button-info mr-2" type="button" onClick={() => {
                        if (value2 !== null && value2?.vendor_Company_ID !== null && value2?.vendor_Company_ID !== 0) {
                            loadConsultants(value2?.vendor_Company_ID || 0);
                        } else props.toast.current.show({ severity: 'error', detail: "Select Vendor Company First.", life: 3000 });
                    }} />
                </div>}
                {props.open && (props.singleData.id === undefined || props.singleData.id === null) && <JVMultiselect column={3} label="Consultants" filter options={consultants} optionLabel="consultant_Name" placeholder="Select Consultants" required value={selectedConsultants} onChange={setSelectedConsultants} />}
                <JVDropdown column={3} label="Type" control={control} name="type_ID" error={errors.type_ID?.message} options={typeTable.tableData} optionLabel="type_Name" optionValue="id" placeholder="Select Type" />
                {props.open && (props.singleData.id !== undefined && props.singleData.id !== null) && <JVDropdown column={3} label="Status" control={control} name="status_ID" error={errors.status_ID?.message} options={statusTable.tableData} optionLabel="status" optionValue="id" placeholder="Select Status" />}
                <div className="field col-12 md:col-12 flex flex-column">
                    <label>Comment : <span style={{ color: 'red' }}>*</span></label>
                    <InputTextarea value={value} onChange={(e) => setValue(e.target.value)} rows={5} cols={30} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} disabled={loading} label="SAVE" type={loading === false ? "submit" : "button"} style={{ width: '100px' }} ></Button>
                    <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" ></Button>
                </div>
            </form>
        </Dialog>
    );
}